
<template>
    <div class="text-caption" style="font-family: 'Poppins', sans-serif;">
        <q-card flat class="" style="border: 1px solid #c2c2c2; border-radius: 0.5rem !important;">
            <!-- <q-chip class="q-mb-md absolute-top" square size="xl" color="primary"  text-color="white" label="SUBSCRIBE"/> -->
            <q-card-section>
                 <!-- :grid="$q.platform.is.mobile ? 'true' : 'false'" -->
                 <!-- <div >{{isDesktop}}</div>
                 <div >{{isMobile}}</div> -->
                <q-table
                   :grid="isMobile ? true : false"
                    dense
                    :data="StoreStateT.Transaction.Investment"
                    :columns="columns"
                    row-key="name"
                    hide-bottom
                    flat
                    separator="none"
                >
                    <template v-slot:body-cell-SchemeName="props">
                        <q-td :props="props">
                            <div class="">
                                {{ props.row.SchemeName }}
                            </div>
                        </q-td>
                    </template>
                    <template v-slot:body-cell-Amount="props">
                        <q-td :props="props">
                            <div class="">
                                {{ props.row.Amount | thousandSeparator}}
                            </div>
                        </q-td>
                    </template>
                    <template v-slot:bottom-row>
                        <q-tr style="border-bottom: 1px solid #063ca1; border-top: 1px solid #063ca1; color: #355dc4;">
                            <q-td align="left">
                                <div class="text-bold">
                                    {{$t("FundInfo.totalamount")}}
                                </div>
                            </q-td>
                            <q-td align="right">
                                <div class="text-bold">
                                    {{TotalInvestment.toFixed(2) | thousandSeparator}}
                                </div>
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>

                <div v-if="isMobile" style="padding: 16px; color: #355dc4;">
                    <div class="text-bold" style="text-transform: uppercase;">
                        {{$t("FundInfo.totalamount")}}
                    </div>
                     <div class="text-bold">
                        {{TotalInvestment.toFixed(2) | thousandSeparator}}
                    </div>
                </div>

            </q-card-section>
        </q-card>
    </div>
</template>

<style>
.q-table__grid-item.col-xs-12.col-sm-6.col-md-4.col-lg-3 {
    border-bottom: 1px solid #c2c2c2;
}
</style>

<script>
import { mapActions } from 'vuex';
import store from '../store'
import ListOfTransaction from '@/components/ListOfTransaction'
export default {
    name : 'TransactionConfirmation',
    components : {
        ListOfTransaction
    },
    props : ['TotalInvestment'],
    data() {
        return {
            StoreStateT : store.state.Transactions,
            columns: [
                { name: 'SchemeName', align: 'left', label: this.$t("FundInfo.fundname"), field: 'SchemeName', sortable: true },
                { name: 'Amount', align: 'right', label: this.$t("FundInfo.investmentamount"), field: 'Amount', sortable: true } 
            ],
            StoreStateT : store.state.Transactions,
            isMobile: this.$q.platform.is.mobile,
            isDesktop: this.$q.platform.is.desktop,
            
        }
    },
    computed: {

    },
    methods: {

    },
    filters: {
    thousandSeparator: function(value) {
        if (value !== '' || value !== undefined || value !== 0  || value !== '0' || value !== '') {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return value;
        }
    }
  }
}
</script>